import axios from "axios";

import { getAuthHeader } from "../headers";

// ===================================================================================
//  GET TRAINING DOCUMENTS
// ===================================================================================
export const trainingDocsLoading = () => {
	return {
		type: "TRAINING_DOCS_ARE_LOADING"
	};
};

export const trainingDocsError = error => {
	return {
		type: "TRAINING_DOCS_HAS_ERROR",
		error
	};
};

export const trainingDocsSuccess = data => {
	return {
		type: "TRAINING_DOCS_SUCCESS",
		data
	};
};

export function getTrainingDocs(isAdmin = false) {
	return (dispatch, getState) => {
		dispatch(trainingDocsLoading());

		const params = { language: process.env.REACT_APP_LANGUAGE };

		return axios
			.get(process.env.REACT_APP_API_URL + "training-docs/groups", {
				headers: getAuthHeader(getState().user, isAdmin),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingDocsError(response.data.errors));
				} else {
					dispatch(trainingDocsSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(trainingDocsError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/trainingDocs.js